var _g, _g2, _path, _rect, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInviteGift = function SvgInviteGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#invite-gift_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF434D",
    d: "M4.61 11.266h12.78v6.854a1.1 1.1 0 0 1-1.1 1.1H5.71a1.1 1.1 0 0 1-1.1-1.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#invite-gift_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#invite-gift_svg__c)",
    d: "M9.9 11.266h2.2v7.954H9.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF434D",
    strokeLinecap: "round",
    strokeWidth: 1.65,
    d: "M11.001 7.098c.61-1.624 2.291-4.557 4.134-3.3 1.78 2.148-1.78 2.724-3.82 3.3M11.001 7.098c-.61-1.624-2.291-4.557-4.134-3.3-1.78 2.148 1.78 2.724 3.82 3.3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.4,
    height: 4.013,
    x: 3.3,
    y: 7.253,
    fill: "#FF434D",
    rx: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD5",
    d: "M9.068 11.266h3.863V7.253H9.068z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "invite-gift_svg__a",
    width: 12.781,
    height: 7.953,
    x: 4.609,
    y: 11.266,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.898137 0 0 0 0 0.178605 0 0 0 0 0.216878 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5926_3575"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "invite-gift_svg__b",
    width: 2.2,
    height: 7.953,
    x: 9.899,
    y: 11.266,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.906494 0 0 0 0 0.713535 0 0 0 0 0.189188 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5926_3575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "invite-gift_svg__c",
    x1: 10.999,
    x2: 10.999,
    y1: 11.266,
    y2: 19.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5",
    stopOpacity: 0.6
  })))));
};
export default SvgInviteGift;